import { BigNumber } from "ethers";

export const makeHumanAmounts = (amount, decimals) => {
  if (decimals == "1")
    return amount
  //console.log("amount", amount);
  return +BigNumber.from(amount).div(decimals.replace("00", "")).toString() / 100;
};
